import './MerchInfo.scss';
import Component from './MerchInfo.js';
export default Component;
